import { render } from "./transferDialog.vue?vue&type=template&id=2a740ff2"
import script from "./transferDialog.vue?vue&type=script&lang=js"
export * from "./transferDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__